import { trustedHostnameSuffixes } from '../constants/index.js'

export const parseHostname = urlString => {
  try {
    const url = new URL(urlString)
    return url.hostname
  } catch {
    return null
  }
}

export const parsePathname = urlString => {
  try {
    const url = new URL(urlString)
    return url.pathname
  } catch {
    return null
  }
}

export const parseUrl = urlString => {
  try {
    const url = new URL(urlString)
    return url
  } catch {
    return null
  }
}

export const withoutProtocol = urlString => {
  try {
    const url = new URL(urlString)
    return url.href.slice(url.protocol.length)
  } catch {
    return null
  }
}

export const addToQuery = (urlString, newQueryName, newQueryValue) => {
  try {
    const url = new URL(urlString)
    url.searchParams.append(newQueryName, newQueryValue)
    return url.href
  } catch {
    return null
  }
}

export function absoluteUrl(relativeUrl, baseUrl) {
  const url = new URL(relativeUrl, baseUrl)
  return url.href
}

export function isTrustedUrl(url) {
  const hostname = parseHostname(url)
  const isTrusted = trustedHostnameSuffixes.some(suffix =>
    hostname.endsWith(suffix)
  )
  return isTrusted ? url : ''
}
